import { render, staticRenderFns } from "./tourist-bar.vue?vue&type=template&id=94852fd2&scoped=true"
import script from "./tourist-bar.vue?vue&type=script&lang=js"
export * from "./tourist-bar.vue?vue&type=script&lang=js"
import style0 from "./tourist-bar.vue?vue&type=style&index=0&id=94852fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94852fd2",
  null
  
)

export default component.exports